import React from 'react'
import { GAMES, GAME_TYPE } from 'lib/constants'
import { GetServerSideProps } from 'next'

import FlexBoxLanding from 'games/flexbox/landing/Landing'
import GridAttackLanding from 'games/gridattack/landing/Landing'
import MCPLanding from 'games/mcp/landing/Landing'
import Layout from 'components/Layout'
import Seo from 'components/Seo'

interface Props {
  gameUrl: GAME_TYPE['url']
}

function Game({ gameUrl }: Props) {
  const game = GAMES.find((game) => game.url === gameUrl)

  if (game?.gameNameId === 'mcp') {
    return (
      <>
        <Seo title={game.seoTitle} description={game.seoDescription} og={'/images/mcp/og.png'} />
        <Layout>
          <MCPLanding game={game} />
        </Layout>
      </>
    )
  }

  if (game?.gameNameId === 'flexbox') {
    return (
      <>
        <Seo title={game.seoTitle} description={game.seoDescription} />
        <Layout>
          <FlexBoxLanding game={game} />
        </Layout>
      </>
    )
  }

  if (game?.gameNameId === 'gridattack') {
    return (
      <>
        <Seo title={game.seoTitle} description={game.seoDescription} />
        <Layout>
          <GridAttackLanding game={game} />
        </Layout>
      </>
    )
  }

  return null
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  if (!context?.params?.gameUrl) {
    console.error(context)
  }

  return {
    props: {
      gameUrl: context?.params?.gameUrl,
    },
  }
}

export default Game
